<template>
    <div class="content-component row" :class="[component.type, {'component-active': isActive}]"
      :style="{order : component.order}" @click="updateCurrentComponent">
        <div   class="image-section column">
            <image-upload v-if="image" class="image-displayed" :component="image" :key="image.id"  :remove="removeImageDetails" :options="options"/>
            <image-upload v-else  :component="{}" :add="newImageDetails" :options="options"/>
        </div>
        <input class="title" type="text" v-model="title" :placeholder="$t('titlePlaceHolder')">
        <span class="legend centered">{{$t(component.text)}}</span>
        <button class="btn secondary delete"  @click="deleteComponent(component)">{{$t('delete')}}</button>
    </div>
</template>
<script>
import BackOfficeComponentMixin from '@/components/BackOffice/Mixins/BackOfficeComponentMixin.js'
export default {
    name: 'SectionTitleContent',
    mixins:[BackOfficeComponentMixin], 
    computed:{
        title:{
            get(){
                return this.component.title[this.locale]
            }, 
            set(value)
            {
                this.setComponentPropertyValue(value, 'title', this.locale)
            }
        }
    }
}
</script>


